import Group from '@mui/icons-material/Group';

import Metadata from '../Metadata';

import { getPartnersString } from '../../services/partners';

export default function CreatorPartners({
  partners = [],
  translations = {
    accessibilityLabel: 'Partners',
  },
  ...otherProps
}) {
  const partnerStrings = getPartnersString(partners);

  if (!partnerStrings) {
    return null;
  }

  return (
    <Metadata icon={Group} {...otherProps} accessibilityLabel={translations.accessibilityLabel}>
      {partnerStrings}
    </Metadata>
  );
}
